import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-storage",
  "use": "app-icon-storage-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"app-icon-storage\"><g data-name=\"icon storage48-\"><path d=\"M41 7a24 24 0 107 17 23.92 23.92 0 00-7-17\" fill=\"#4d84ff\" /><path d=\"M10 17h28a2 2 0 012 2v10a2 2 0 01-2 2H10a2 2 0 01-2-2V19a2 2 0 012-2zm2 6v2h2v-2zm4 0v2a50.5 50.5 0 0120 0v-2a50.5 50.5 0 00-20 0z\" fill=\"#fff\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol